import { SearchableItem, SearchableSelectionType } from "./interface";


export class Rma implements SearchableItem {
  ID: string;
  NAICS: number;
  REGION: string;
  INDUSTRY_SUBSET: string;

  TOTAL_ASSETS: number;
  MINUS_LIABILITIES: number;
  PLUS_CPLTD: number;
  WORKING_CAPITAL: number;
  TOTAL_SALES: number;
  WC_TOTAL_SALES: number;

  NET_SALES: number;
  COST_OF_SALES: number;
  GROSS_PROFIT: number;
  OPERATING_EXPENSES: number;
  OPERATING_PROFIT: number;

  CASH_EQUIVALENTS: number;
  TRADE_RECEIVABLES: number;
  INVENTORY: number;
  OTHER_CURRENT_ASSETES: number;
  TOTAL_CURRENT_ASSETES: number;
  FIXED_ASSETS: number;
  INTANGIBLES: number;
  NON_CURRENT_ASSETS: number;
  TOTAL: number;

  NOTES_PAYABLE: number;
  CUR_MAT: number;
  TRADE_PAYABLE: number;
  TAXES_PAYABLE: number;
  OTHER_CURRENT_WORTH: number;
  TOTAL_CURRENT_WORTH: number;
  LT_DEBT: number;
  DEFERRED_TAXES: number;
  NON_CURRENT_WORTH: number;
  NET_WORTH: number;
  TOTAL_NET_WORTH: number;

  CURRENT_RATIO: number;
  QUICK_RATIO: number;
  SALES_RECEIVABLES: number;
  COGS_INVENTORY: number;
  COGS_PAYABLE: number;

  // Hellpers
  active = false;
  selected = false;
  allowed: boolean = false;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parse(json: any): Rma {
    if (json) {
      const f = new Rma();
      f.ID = json.ID;
      f.NAICS = json.NAICS;
      f.REGION = json.REGION;
      f.INDUSTRY_SUBSET = json.INDUSTRY_SUBSET;

      f.TOTAL_ASSETS = json.TOTAL_ASSETS;
      f.MINUS_LIABILITIES = json.MINUS_LIABILITIES;
      f.PLUS_CPLTD = json.PLUS_CPLTD;
      f.WORKING_CAPITAL = json.WORKING_CAPITAL;
      f.TOTAL_SALES = json.TOTAL_SALES;
      f.WC_TOTAL_SALES = json.WC_TOTAL_SALES;

      f.NET_SALES = json.NET_SALES;
      f.COST_OF_SALES = json.COST_OF_SALES;
      f.GROSS_PROFIT = json.GROSS_PROFIT;
      f.OPERATING_EXPENSES = json.OPERATING_EXPENSES;
      f.OPERATING_PROFIT = json.OPERATING_PROFIT;

      f.CASH_EQUIVALENTS = json.CASH_EQUIVALENTS;
      f.TRADE_RECEIVABLES = json.TRADE_RECEIVABLES;
      f.INVENTORY = json.INVENTORY;
      f.OTHER_CURRENT_ASSETES = json.OTHER_CURRENT_ASSETES;
      f.TOTAL_CURRENT_ASSETES = json.TOTAL_CURRENT_ASSETES;
      f.FIXED_ASSETS = json.FIXED_ASSETS;
      f.INTANGIBLES = json.INTANGIBLES;
      f.NON_CURRENT_ASSETS = json.NON_CURRENT_ASSETS;
      f.TOTAL = json.TOTAL;

      f.NOTES_PAYABLE = json.NOTES_PAYABLE;
      f.CUR_MAT = json.CUR_MAT;
      f.TRADE_PAYABLE = json.TRADE_PAYABLE;
      f.TAXES_PAYABLE = json.TAXES_PAYABLE;
      f.OTHER_CURRENT_WORTH = json.OTHER_CURRENT_WORTH;
      f.TOTAL_CURRENT_WORTH = json.TOTAL_CURRENT_WORTH;
      f.LT_DEBT = json.LT_DEBT;
      f.DEFERRED_TAXES = json.DEFERRED_TAXES;
      f.NON_CURRENT_WORTH = json.NON_CURRENT_WORTH;
      f.NET_WORTH = json.NET_WORTH;
      f.TOTAL_NET_WORTH = json.TOTAL_NET_WORTH;

      f.CURRENT_RATIO = json.CURRENT_RATIO;
      f.QUICK_RATIO = json.QUICK_RATIO;
      f.SALES_RECEIVABLES = json.SALES_RECEIVABLES;
      f.COGS_INVENTORY = json.COGS_INVENTORY;
      f.COGS_PAYABLE = json.COGS_PAYABLE;

      return f;
    } else { return null; }
  }

  static parseArray(json: any[]): Rma[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(Rma.parse(j));
        }
      }
    }
    return arr;
  }

  getName(): string {
    return this.INDUSTRY_SUBSET
  }

  getFullDetails(): string {
    return 'RMA';
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
